import * as THREE from 'three'

const material_map = new Map()

// ROAD_MOCKED 虚拟车道配置常量
const ROAD_MOCKED_COLOR = 0x8b00ff  // 深紫
const ROAD_MOCKED_DASH_SIZE = 0.2
const ROAD_MOCKED_GAP_SIZE = 0.2

// 这些是”区域底色”类型的面元素。
// 它们的职责是给地图提供范围提示，不应该压过 lane / boundary / stop_line。
const SURFACE_ELEMENT_NAMES = new Set([
  'clear_zone',
  'cross_walk',
  'free_area',
  'parking',
  'pillar',
  'prohibited_area',
  'speed_bump',
  'safety_island',
  'multiLayerArea'
])

// 第二轮视觉优化：
// 1. 区域底色继续变淡，减少大面积铺色带来的压迫感；
// 2. 不同区域按语义保留轻微差异，但整体都控制在“弱提示”强度；
// 3. 目标是让用户先看到 lane / boundary，再感知区域范围。
const DEFAULT_SURFACE_OPACITY = 0.12
const SURFACE_OPACITY_BY_NAME = {
  cross_walk: 0.14,
  clear_zone: 0.12,
  free_area: 0.1,
  parking: 0.1,
  pillar: 0.14,
  prohibited_area: 0.14,
  speed_bump: 0.48,
  safety_island: 0.12,
  multiLayerArea: 0.1
}
const SURFACE_COLOR_SOFTEN_RATIO = 0.28

const MateialSetting = {
  stop_line_1: {
    type: 'LineBasic',
    setting: {
      color: 0xffff00
    }
  },
  stop_line_2: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 1,
      gapSize: 0.5
    }
  },
  stop_line_3: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  stop_line_4: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  stop_line_UNKNOWN: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00
    }
  },
  entry_line_UNKNOWN: {
    type: 'LineDashed',
    setting: {
      color: 0xff8800
    }
  },
  boundary_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_1: {
    type: 'LineDashed',
    setting: {
      color: 0xf0dc70,
      dashSize: 1,
      gapSize: 0.5
    }
  },
  boundary_2: {
    type: 'LineDashed',
    setting: {
      color: 0xf0dc70,
      dashSize: 1,
      gapSize: 0.5
    }
  },
  boundary_3: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_4: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_5: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },

  boundary_7: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_8: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_9: {
    type: 'LineDashed',
    setting: {
      color: 0xf0dc70,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  boundary_10: {
    type: 'LineDashed',
    setting: {
      color: 0xf0dc70,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  lane_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_1: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_2: {
    type: 'LineBasic',
    setting: {
      color: 0x494e8f
    }
  },
  lane_3: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_4: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_5: {
    type: 'LineBasic',
    setting: {
      color: 0x494e8f
    }
  },
  lane_6: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_7: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_virtual_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_virtual_1: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_virtual_2: {
    type: 'LineBasic',
    setting: {
      color: 0x494e8f
    }
  },
  lane_virtual_3: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  // ROAD_MOCKED(virtual_type=2) 道路虚拟车道：亮粉红密集短虚线，与路口虚拟车道(lane_virtual)及边界长虚线区分
  lane_road_mocked_UNKNOWN: {
    type: 'LineDashed',
    setting: {
      color: ROAD_MOCKED_COLOR,
      dashSize: ROAD_MOCKED_DASH_SIZE,
      gapSize: ROAD_MOCKED_GAP_SIZE
    }
  },
  lane_road_mocked_1: {
    type: 'LineDashed',
    setting: {
      color: ROAD_MOCKED_COLOR,
      dashSize: ROAD_MOCKED_DASH_SIZE,
      gapSize: ROAD_MOCKED_GAP_SIZE
    }
  },
  lane_road_mocked_2: {
    type: 'LineDashed',
    setting: {
      color: ROAD_MOCKED_COLOR,
      dashSize: ROAD_MOCKED_DASH_SIZE,
      gapSize: ROAD_MOCKED_GAP_SIZE
    }
  },
  lane_road_mocked_3: {
    type: 'LineDashed',
    setting: {
      color: ROAD_MOCKED_COLOR,
      dashSize: ROAD_MOCKED_DASH_SIZE,
      gapSize: ROAD_MOCKED_GAP_SIZE
    }
  },
  cross_walk_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x00ae9d,
      side: THREE.DoubleSide
    }
  },
  clear_zone_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xd71345,
      side: THREE.DoubleSide
    }
  },
  free_area_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_3: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_4: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_5: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_6: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_7: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_8: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_9: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_10: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  gate_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_1: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_2: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_3: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_4: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_5: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  intersection_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0x501013
    }
  },
  parking_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  parking_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  parking_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  pillar_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xf47920,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_3: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  speed_bump_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xffeb3b,
      side: THREE.DoubleSide
    }
  },
  safety_island_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xdf8864,
      side: THREE.DoubleSide
    }
  },
  multiLayerArea_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x118864,
      side: THREE.DoubleSide
    }
  },
  free_area_solid: {
    type: 'LineBasic',
    setting: {
      color: 0x007947
    }
  },
}

function getMateial(elementName, elementType) {
  elementType = elementType || 'UNKNOWN'
  const key = `${elementName}_${elementType}`
  if (material_map.has(key)) {
    return material_map.get(key)
  }
  const mSetting = MateialSetting[key]
  if (!mSetting) {
    return getMateial(elementName, 0)
  }
  let material = null
  switch (mSetting.type) {
    case 'LineBasic':
      material = new THREE.LineBasicMaterial(mSetting.setting)
      break
    case 'LineDashed':
      material = new THREE.LineDashedMaterial(mSetting.setting)
      break
    case 'MeshBasic':
      material = new THREE.MeshBasicMaterial(mSetting.setting)
      break
    default:
      console.log('getMateial error')
  }

  material.transparent = true

  if (SURFACE_ELEMENT_NAMES.has(elementName)) {
    // 面元素现在按“背景底纹”处理，而不是“强覆盖层”。
    // 这里做 4 件事：
    // 1. 统一把透明度再压低，降低大色块的侵入感；
    // 2. 轻微向白色靠拢，削弱高饱和颜色的刺眼感；
    // 3. 关闭 depthWrite，避免透明面把后画的线条压暗；
    // 4. 开启 polygonOffset，让面在深度计算里再往后退一点，减少贴线时的冲突感。
    material.opacity = SURFACE_OPACITY_BY_NAME[elementName] ?? DEFAULT_SURFACE_OPACITY
    material.depthWrite = false
    material.polygonOffset = true
    material.polygonOffsetFactor = 1
    material.polygonOffsetUnits = 1
    if (material.color) {
      const softenRatio = elementName === 'speed_bump' ? 0.08 : SURFACE_COLOR_SOFTEN_RATIO
      material.color.lerp(new THREE.Color(0xffffff), softenRatio)
    }
  }

  material_map.set(key, material)
  return material
}
/**
 *
 * @param {*} param0
 */
export function createLine({ name, type, element }) {
  const points = [];
  element.pointList.forEach((e) => {
    // points.push(new THREE.Vector3(e.x, 0, -e.y));
    points.push(new THREE.Vector3(e.x, e.y, 0));
  });
  const geometry = new THREE.BufferGeometry().setFromPoints(points);
  let material = getMateial(name, type);
  const line = new THREE.Line(geometry, material);
  line.computeLineDistances();
  line.renderOrder = 100;
  let center = getCenterForObstacle(element.pointList);
  line.positionEX = center;
  line.matrixAutoUpdate = false;
  return line;
}
export function createMesh({ name, element }) {
  let heartShape = new THREE.Shape();
  element.pointList.forEach((e, index) => {
    if (index == 0) {
      heartShape.moveTo(e.x, e.y);
    } else {
      heartShape.lineTo(e.x, e.y);
    }
  });
  const geometry_shape = new THREE.ShapeGeometry(heartShape);
  const material_shape = getMateial(name, undefined);
  // material_shape.depthTest = false;
  const mesh = new THREE.Mesh(geometry_shape, material_shape);
  mesh.renderOrder = -99;
  mesh.matrixAutoUpdate = false;

  //创建面的边界
  if (name == "free_area" || name == "parking") {
    const points = [];
    element.pointList.forEach((e) => {
      points.push(new THREE.Vector3(e.x, e.y, 0));
    });
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    let material = getMateial("free_area", "solid");
    const line = new THREE.Line(geometry, material);
    line.computeLineDistances();
    line.renderOrder = 1;
    mesh.add(line);
  }

  return mesh;
}


const getCenterForObstacle = (polygonList = []) => {
  if (polygonList.length > 0) {
    let sum = polygonList.reduce(
      (pre, cur) => {
        return { x: pre.x + cur.x, y: pre.y + cur.y }
      },
      { x: 0, y: 0 }
    )
    let center = {
      x: sum.x / polygonList.length,
      y: sum.y / polygonList.length
    }
    return center
  } else {
    return { x: 0, y: 0 }
  }
}



